<template>
  <div class="landing-page">
    <!--<template>
      <div><notification-banner v-if="showNotification" @close="hideNotification" /></div>
    </template>-->
    <template>
      <div>
        <h1 class="title">Welcome, {{ user.name }}</h1>
        <p>
          Welcome to your personalized member portal. This is your one-stop shop for everything OHI.
          View or edit your business info, update your GoCampingAmerica listing, pay invoices,
          access your music license certificates, and more. Need assistance? Get in touch through
          the contact us page or ring us at 303-681-0401.
        </p>
        <PortalSection />
        <AnnouncementItem />
        <LinkCard />
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import PortalSection from '../components/PortalSection.vue';
import AnnouncementItem from '../components/AnnouncementItem.vue';
import LinkCard from '../components/LinkCard.vue';
// import Multiselect from 'vue-multiselect';
// import NotificationBanner from './NotificationBanner.vue';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;
export default {
  name: 'Landing',
  components: {
    PortalSection,
    AnnouncementItem,
    LinkCard,
    // NotificationBanner,
  },
  data() {
    return {
      user: {},
      showModal: false,
      // showNotification: true,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    hideNotification() {
    // this.showNotification = false;
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawContact = await axios.get(`${server}/api/contact`);
        if (rawContact.data.redirect) {
          localStorage.setItem('postLogin', window.location.href);
          // eslint-disable-next-line no-restricted-globals
          location.href = `${rawContact.data.redirect}?r=${location.href}`;
        } else if (rawContact.data) {
          const myContact = rawContact.data;
          this.user = {
            contactId: myContact.Id,
            email: myContact.Email,
            membership: myContact.FS_Membership_Type1__c,
            name: `${myContact.FirstName} ${myContact.LastName}`,
            badges: myContact.OrderApi__Badges__c,
          };
          this.isEmulating = myContact.isEmulating;
          localStorage.setItem('arvcportal_user', JSON.stringify(this.user));
        } else {
          this.loadingMessage = 'There was an issue logging you in. Please let us know so we can investigate!';
        }
      } catch (err) {
        console.log({ contactError: err });
      }
    });
  },
};
</script>

<style lang="scss"></style>
